import { render } from "./TDBG18.vue?vue&type=template&id=2464167a&scoped=true"
import script from "./TDBG18.vue?vue&type=script&lang=js"
export * from "./TDBG18.vue?vue&type=script&lang=js"

import "./TDBG18.vue?vue&type=style&index=0&id=2464167a&lang=css"
import "./TDBG18.vue?vue&type=style&index=1&id=2464167a&scoped=true&lang=css"

import exportComponent from "D:\\wcb\\www\\wifigolf\\s_api\\public\\ClpgaApp121\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2464167a"]])

export default __exports__